export default (obj) => {

    return `
        
        <div class="container hero__container">
            <div class="row">
                <div class="col hero__main hero__imagebackground ${obj.cssHooks} text-center" ${obj.image ? `style="background-image:url(${obj.image})"` : ""}>
                    <div class="row justify-content-center">
                        <div class="col-sm-8">
                            <h1 class="hero__title">${obj.title}</h1>
                            <p class="hero__intro">${obj.intro}</p>
                        </div>
                        <div class="col-12 p-0">
                            <div class="row hero__linkcontainer row-eq-height">${obj.herolinks}</div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    
    `;

}

export const herolink = (obj) => {
    return `
    <div class="col-lg-6">
        <a href="${obj.link}" class="herolink herolink-${obj.cssclass} text-left">
            <span class="material-icons-outlined herolink__icon">${obj.icon}</span>
            <span class="herolink__title">${obj.title}</span>
            <span class="herolink__subtext">${obj.description}</span>
        </a>
    </div>
    
    `;
}

export const herosearchHtml = (obj) => {

    return `
        
        <div class="container hero__container">
            <div class="row">
                <div class="col  hero__main hero__libary">
                    <div class="row justify-content-center">
                        <div class="col-sm-8">
                            <h1 class="hero__title hero__title-dark">${obj.title}</h1>
                            <p class="hero__intro hero__intro-dark text-center">${obj.intro}</p>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-lg-6 mt-5 ml-5 mr-5 ml-md-0 mr-md-0 pl-0 pr-0">
                            <input type="text" class="form-control form__input" id="searchheader__inputfield" placeholder="Søk etter f.eks. gatenavn">
                            <button class="form__hoversearch" id="searchheader__button" ><span class="material-icons-outlined form__hoversearch__icon">search</span></button>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12 p-0 text-center">
                            <div class="hero__presearchlink__container">
                                ${obj.herolinks}
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
    
    `;

}

export const presearchlinksHtml = (search) => {
    const searchInfo = search.split(";");
    const linkText = searchInfo[0];
    const searchParameter = searchInfo[1] || "";

    return `<a href="/${site}/sok/?q=&${searchParameter}" class="hero__presearchlink">${linkText}</a>`

}
